import { render, staticRenderFns } from "./clear.vue?vue&type=template&id=4811a540&scoped=true&"
import script from "./clear.vue?vue&type=script&lang=js&"
export * from "./clear.vue?vue&type=script&lang=js&"
import style0 from "./clear.vue?vue&type=style&index=0&id=4811a540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4811a540",
  null
  
)

component.options.__file = "clear.vue"
export default component.exports